"use client";
import {
  useRadioStore
} from "../__chunks/4BXJGRNH.js";
import {
  RadioContextProvider
} from "../__chunks/UVUMR3WP.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/radio/radio-provider.tsx
import { jsx } from "react/jsx-runtime";
function RadioProvider(props = {}) {
  const store = useRadioStore(props);
  return /* @__PURE__ */ jsx(RadioContextProvider, { value: store, children: props.children });
}
export {
  RadioProvider
};
